import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { ClipBoardService } from '../../../services/clipboard.service'
import { ServerService } from '../../../services/server.service'
import { IMyDateRangeModel } from 'mydaterangepicker';
import { Observable } from 'rxjs';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-escalation-filter-modal',
  templateUrl: './escalation-filter-modal.component.html',
  styleUrls: ['./escalation-filter-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EscalationFilterModalComponent implements OnInit {

  public authToken = localStorage.getItem("token");
  public projectInfo = JSON.parse(localStorage.getItem('projectInfo'));
  userInfo: any = JSON.parse(localStorage.getItem("userInfo"))

  showComponentLoader: boolean = true;

  campaignList: any;
  getEscalationCategory: any;
  assignedUserList: any;
  escalationStatusList: any;
  createdByList: any;

  createdAt:any;
  completedAt:any;
  resolvedAt:any;
  selectedCampaign:any;
  selectedEscalationCategory:any;
  selectedAssignedTo:any;
  selectedCreatedBy:any;
  selectedPriority:any;
  selectedStatus:any;

  myDateRangePickerOptions = {     
    dateFormat: 'dd.mm.yyyy'      
};
  
  constructor(
    private serverService: ServerService,
    private clipBoardService: ClipBoardService,
    private dialogRef: MatDialogRef<EscalationFilterModalComponent>,
    @Inject(MAT_DIALOG_DATA) private data
  ) {

    if (data.created_at != undefined) {
      this.createdAt = data.created_at;
    }

    // if (data.completedAt != undefined) {
    //   this.completedAt = data.completedAt;
    // }

    if (data.resolution_at != undefined) {
      this.resolvedAt = data.resolution_at;
    }

    if (data.campaign_id != undefined) {
      this.selectedCampaign = data.campaign_id;
    }

    if (data.escalation_category != undefined) {
      this.selectedEscalationCategory = data.escalation_category;
    }

    if (data.assigned_to_id != undefined) {
      this.selectedAssignedTo = data.assigned_to_id
    }

    if (data.created_by_id != undefined) {
      this.selectedCreatedBy = data.created_by_id
    }

    if (data.priority != undefined) {
      this.selectedPriority = data.priority
    }

    if (data.status != undefined) {
      this.selectedStatus = data.status
    }

  }

  ngOnInit() {
    this.getCommon()
    this.getCampaignForFilter()
    this.getAssignUser()
    this.getCreatedBy()
  }

  getCommon() {

    this.showComponentLoader = true;

    let url = "campaign_module/get_common_details"

    this.serverService.getEscalationCategory(url, this.authToken).subscribe(data => {
      //console.log(data)
      this.getEscalationCategory = data.escalation_category_list
      this.escalationStatusList = data.escalation_status_list
      this.showComponentLoader = false
    },
      err => {
        this.showComponentLoader = false
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )
  }
  
  getCampaignForFilter() {

    this.showComponentLoader = true;

    this.serverService.getCampaignForFilter("campaign_module/campaign/list", this.authToken).subscribe(
      data => {
        this.campaignList = data;
        this.showComponentLoader = false
      },
      err => {
        this.showComponentLoader = false
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )
  }

  getAssignUser() {

    this.showComponentLoader = true

    let url = "/campaign_module/user_list";
    this.serverService.getMM(url, this.authToken).subscribe(data => {
      this.assignedUserList = data.data
      //console.log(this.mmList)
      this.showComponentLoader = false
    },
      err => {
        this.showComponentLoader = false
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )

  }

  getCreatedBy() {

    this.showComponentLoader = true

    let url = "/campaign_module/user_list";
    this.serverService.getSalePerson(url, this.authToken).subscribe(data => {
      this.createdByList = data.data
      //console.log(this.salePersonList)
      this.showComponentLoader = false
    },
      err => {
        this.showComponentLoader = false
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )

  }

  filter() {

    let body = {}

    if (this.createdAt != undefined && this.createdAt != "") {
      body["created_at"] = this.createdAt;      
    }

    // if (this.completedAt != undefined && this.completedAt != '') {
    //   body["completed_at"] = this.completedAt
    // }

    if (this.resolvedAt != undefined && this.resolvedAt != "") {
      body["resolution_at"] = this.resolvedAt;
    }

    if (this.selectedCampaign != undefined && this.selectedCampaign != "") {
      body["campaign_id"] = this.selectedCampaign;
    }

    if ((this.selectedEscalationCategory != undefined || this.selectedEscalationCategory != null) && this.selectedEscalationCategory != "") {
      body["escalation_category"] = this.selectedEscalationCategory;
    }

    if (this.selectedAssignedTo != undefined && this.selectedAssignedTo != "") {
      body["assigned_to_id"] = this.selectedAssignedTo
    }

    if (this.selectedCreatedBy != undefined && this.selectedCreatedBy != "") {
      body["created_by_id"] = this.selectedCreatedBy
    }

    if (this.selectedPriority != undefined && this.selectedPriority != "") {
      body["priority"] = this.selectedPriority
    }

    if (this.selectedStatus != undefined && this.selectedStatus != "") {
      body["status"] = this.selectedStatus
    }

    //console.log(body)
    // return false

    this.dialogRef.close(body)
  }

  close() {
    this.dialogRef.close();
  }

  clear() {
    this.createdAt=null;
    this.completedAt=null;
    this.resolvedAt=null;
    this.selectedCampaign=null;
    this.selectedEscalationCategory=null;
    this.selectedAssignedTo=null;
    this.selectedCreatedBy=null;
    this.selectedPriority=null;
    this.selectedStatus=null;
  }

}
